import { assertClientSide } from '@dr.pogodin/react-utils';

import type * as RealtimeAi from 'client/services/ai/realtime';
import type * as Audio from 'client/services/audio';
import type * as Firebase from 'client/services/firebase';

export async function getAudioClientService(): Promise<typeof Audio> {
  assertClientSide();
  return import(/* webpackChunkName: "audio-client-service" */
    'client/services/audio'
  );
}

export async function getFirebaseClientService():
Promise<typeof Firebase> {
  assertClientSide();
  return import(/* webpackChunkName: "firebase-client-service" */
    'client/services/firebase'
  );
}

export async function getRealtimeAiClient():
Promise<typeof RealtimeAi> {
  assertClientSide();
  return import(/* webpackChunkName: "ai-realtime-service" */
    'client/services/ai/realtime'
  );
}
